import { MARKET } from '.';

// eslint-disable-next-line import/prefer-default-export
export type SimpleAndRegularFilterOptions = {
  name: string;
  key: string;
  filterType: string;
  options: string[];
};
export type ComplexFilterOptions = {
  name: string;
  key?: string;
  filterType: string;
  options: {
    [key: string]: {
      [key: string]: string[];
    };
  };
};
export type RangeFilterOption = {
  name: string;
  key: string;
  filterType: string;
  options: {
    min: number[];
    max: number[];
  };
};

export type RangeFilterOptions = {
  [key: string]: RangeFilterOption;
};
export interface FilterOptionsTypes {
  [key: string]: SimpleAndRegularFilterOptions | ComplexFilterOptions | RangeFilterOption;
}

export const TYPE_QUERY_OPTIONS = {
  name: 'type',
  key: 'type',
  filterType: 'simple',
  options: ['new', 'used', 'cpo'],
};

export const USED_INVENTORY_TYPE_QUERY_OPTIONS = {
  name: 'usedInventoryType',
  key: 'usedInventoryType',
  filterType: 'simple',
  options: [
    'has-warranties.all',
    'has-warranties.yes',
    'has-warranties.no',
    'foreign-brand.yes',
    'has-warranties.combined',
  ],
};

export const NON_AUDI_QUERY_OPTIONS = {
  name: 'nonAudi',
  key: 'nonAudi',
  filterType: 'simple',
  options: ['foreign-brand.yes', 'foreign-brand.no'],
};

export const AVAILABLE_IN_MONTHS_QUERY_OPTIONS = {
  name: 'availableInMonths',
  key: 'availableInMonths',
  filterType: 'simple',
  options: ['0', '3'],
};

export const CARLINE_GROUP_QUERY_OPTIONS = {
  name: 'carline-group',
  key: 'modelFamily',
  filterType: 'complex',
  options: {
    a3: {
      modelFamily: ['a3', 's3', 'rs3'],
    },
    a4: {
      modelFamily: ['a4', 's4'],
    },
    a4etron: {
      modelFamily: ['a4etron', 's4etron'],
    },
    a5: {
      modelFamily: ['a5', 's5', 'rs5'],
    },
    allnewa5: {
      modelFamily: ['a5-new', 's5-new'],
    },
    a6: {
      modelFamily: ['a6', 's6', 'rs6'],
    },
    a6etron: {
      modelFamily: ['a6etron', 's6etron'],
    },
    a7: {
      modelFamily: ['a7', 's7', 'rs7'],
    },
    a8: {
      modelFamily: ['a8', 's8'],
    },
    q3: {
      modelFamily: ['q3'],
    },
    q4: {
      modelFamily: ['q4'],
    },
    q4etron: {
      modelFamily: ['q4'],
    },
    allnewq5: {
      modelFamily: ['q5-new', 'sq5-new'],
    },
    q5: {
      modelFamily: ['q5', 'sq5'],
    },
    q6: {
      modelFamily: ['q6etron', 'sq6etron'],
    },
    q6etron: {
      modelFamily: ['q6etron', 'sq6etron'],
    },
    q7: {
      modelFamily: ['q7', 'sq7'],
    },
    q8etron: {
      modelFamily: ['q8etron', 'sq8etron'],
    },
    q8: {
      modelFamily: ['q8', 'sq8', 'rsq8', 'q8etron', 'sq8etron'],
    },
    tt: {
      modelFamily: ['tt', 'tts', 'ttrs'],
    },
    r8: {
      modelFamily: ['r8'],
    },
    etron: {
      modelFamily: [
        'etron',
        'q4',
        'q6etron',
        'sq6etron',
        'q8etron',
        'sq8etron',
        'etrongt',
        'rsetrongt',
      ],
    },
    etrongt: {
      modelFamily: ['etrongt', 'rsetrongt'],
    },
  },
};
export const CARLINE_QUERY_OPTIONS = {
  name: 'carline',
  filterType: 'complex',
  options: {
    a3limo: {
      modelFamily: ['a3'],
      bodyType: ['limousine'],
    },
    s3limo: {
      modelFamily: ['s3'],
      bodyType: ['limousine'],
    },
    rs3limo: {
      modelFamily: ['rs3'],
      bodyType: ['limousine'],
    },
    // A4
    a4limo: {
      modelFamily: ['a4'],
      bodyType: ['limousine'],
    },
    a4aq: {
      modelFamily: ['a4'],
      bodyType: ['allroad_quattro'],
    },
    s4limo: {
      modelFamily: ['s4'],
      bodyType: ['limousine'],
    },
    // A5
    a5coupe: {
      modelFamily: ['a5'],
      bodyType: ['coupe'],
    },
    a5sb: {
      modelFamily: ['a5'],
      bodyType: ['sportback'],
    },
    a5cabrio: {
      modelFamily: ['a5'],
      bodyType: ['cabriolet'],
    },
    a5limo: {
      modelFamily: ['a5-new'],
      bodyType: ['limousine'],
    },
    s5coupe: {
      modelFamily: ['s5'],
      bodyType: ['coupe'],
    },
    s5sb: {
      modelFamily: ['s5'],
      bodyType: ['sportback'],
    },
    s5cabrio: {
      modelFamily: ['s5'],
      bodyType: ['cabriolet'],
    },
    s5limo: {
      modelFamily: ['s5-new'],
      bodyType: ['limousine'],
    },
    rs5coupe: {
      modelFamily: ['rs5'],
      bodyType: ['coupe'],
    },
    rs5sb: {
      modelFamily: ['rs5'],
      bodyType: ['sportback'],
    },
    // A6
    a6limo: {
      modelFamily: ['a6'],
      bodyType: ['limousine'],
    },
    a6etron: {
      modelFamily: ['a6etron'],
      bodyType: ['sportback'],
    },
    a6aq: {
      modelFamily: ['a6'],
      bodyType: ['allroad_quattro'],
    },
    s6limo: {
      modelFamily: ['s6'],
      bodyType: ['limousine'],
    },
    s6etron: {
      modelFamily: ['s6etron'],
      bodyType: ['sportback'],
    },
    rs6avant: {
      modelFamily: ['rs6'],
      bodyType: ['avant'],
    },
    // A7
    a7sb: {
      modelFamily: ['a7'],
      bodyType: ['sportback'],
    },
    s7sb: {
      modelFamily: ['s7'],
      bodyType: ['sportback'],
    },
    rs7sb: {
      modelFamily: ['rs7'],
      bodyType: ['sportback'],
    },
    // A8
    a8l: {
      modelFamily: ['a8'],
      bodyType: ['limousine'],
    },
    s8l: {
      modelFamily: ['s8'],
      bodyType: ['limousine'],
    },
    // Q3
    q3: {
      modelFamily: ['q3'],
      bodyType: ['suv'],
    },
    // Q4
    q4: {
      modelFamily: ['q4'],
    },
    q4etron: {
      modelFamily: ['q4'],
      bodyType: ['suv'],
    },
    q4sbetron: {
      modelFamily: ['q4'],
      bodyType: ['sportback'],
    },
    // Q5
    q5: {
      modelFamily: ['q5'],
      bodyType: ['suv'],
    },
    allnewq5: {
      modelFamily: ['q5-new'],
      bodyType: ['suv'],
    },
    q5sb: {
      modelFamily: ['q5'],
      bodyType: ['sportback'],
    },
    allnewq5sb: {
      modelFamily: ['q5-new'],
      bodyType: ['sportback'],
    },
    q5etron: {
      modelFamily: ['q5'],
      bodyType: ['suv'],
      fuelType: ['gasoline_hybrid'],
    },
    q5tfsie: {
      modelFamily: ['q5'],
      bodyType: ['suv'],
      fuelType: ['gasoline_hybrid'],
    },
    sq5: {
      modelFamily: ['sq5'],
      bodyType: ['suv'],
    },
    allnewsq5: {
      modelFamily: ['sq5-new'],
      bodyType: ['suv'],
    },
    sq5sb: {
      modelFamily: ['sq5'],
      bodyType: ['sportback'],
    },
    allnewsq5sb: {
      modelFamily: ['sq5-new'],
      bodyType: ['sportback'],
    },
    // Q6
    q6etron: {
      modelFamily: ['q6etron'],
      bodyType: ['suv'],
    },
    sq6etron: {
      modelFamily: ['sq6etron'],
      bodyType: ['suv'],
    },
    // Q7
    q7: {
      modelFamily: ['q7'],
      bodyType: ['suv'],
    },
    sq7: {
      modelFamily: ['sq7'],
      bodyType: ['suv'],
    },
    // Q8
    q8: {
      modelFamily: ['q8'],
      bodyType: ['suv'],
    },
    q8etron: {
      modelFamily: ['q8etron'],
      bodyType: ['suv'],
    },
    sq8etron: {
      modelFamily: ['sq8etron'],
      bodyType: ['suv'],
    },
    q8sbetron: {
      modelFamily: ['q8etron'],
      bodyType: ['sportback'],
    },
    sq8sbetron: {
      modelFamily: ['sq8etron'],
      bodyType: ['sportback'],
    },
    sq8: {
      modelFamily: ['sq8'],
      bodyType: ['suv'],
    },
    rsq8: {
      modelFamily: ['rsq8'],
      bodyType: ['suv'],
    },
    // etron
    etron: {
      modelFamily: ['etron'],
      bodyType: ['suv'],
    },
    etrons: {
      modelFamily: ['etron'],
      bodyType: ['sportback'],
    },
    etronsb: {
      modelFamily: ['etron'],
      bodyType: ['sportback'],
    },
    // etron GT
    etrongt: {
      modelFamily: ['etrongt'],
      bodyType: ['limousine'],
    },
    rsetrongt: {
      modelFamily: ['rsetrongt'],
      bodyType: ['limousine'],
    },
    // TT
    ttcoupe: {
      modelFamily: ['tt'],
      bodyType: ['coupe'],
    },
    ttroadster: {
      modelFamily: ['tt'],
      bodyType: ['roadster'],
    },
    ttscoupe: {
      modelFamily: ['tts'],
      bodyType: ['coupe'],
    },
    ttrscoupe: {
      modelFamily: ['ttrs'],
      bodyType: ['coupe'],
    },
    // R8
    r8: {
      modelFamily: ['r8'],
      bodyType: ['coupe'],
    },
    r8spyder: {
      modelFamily: ['r8'],
      bodyType: ['spyder'],
    },
    r8performance: {
      modelFamily: ['r8'],
      bodyType: ['coupe'],
    },
    r8spyderperformance: {
      modelFamily: ['r8'],
      bodyType: ['spyder'],
    },
  },
};
export const BODY_STYLE_QUERY_OPTIONS = {
  name: 'bodyType',
  key: 'bodyType',
  filterType: 'regular',
  options: [
    'suv',
    'limousine',
    'allroad_quattro',
    'coupe',
    'sportback',
    'spyder',
    'roadster',
    'cabriolet',
    'sportscar',
    'avant',
  ],
};
export const TRIMLINE_QUERY_OPTIONS = {
  name: 'trimline',
  key: 'trimLine',
  filterType: 'regular',
  options:
    MARKET === 'CAN'
      ? ['comfort', 'progressive', 'technik']
      : ['premium', 'premium_plus', 'prestige', 'other'],
};

export const MODEL_FAMILY_QUERY_OPTIONS = {
  name: 'modelFamily',
  key: 'modelFamily',
  filterType: 'regular',
  options: [
    'a3',
    's3',
    'a4',
    's4',
    'a5',
    'a5-new',
    's5',
    's5-new',
    'a6',
    'a6etron',
    's6',
    's6etron',
    'a7',
    's7',
    'a8',
    's8',
    'etron',
    'etrons',
    'etrongt',
    'rsetrongt',
    'q4',
    'q8etron',
    'sq8etron',
    'q3',
    'q5',
    'q5-new',
    'q5tfsie',
    'sq5',
    'sq5-new',
    'q6etron',
    'sq6etron',
    'q7',
    'sq7',
    'q8',
    'sq8',
    'rs3',
    'rs5',
    'rs6',
    'rs7',
    'r8',
    'rsq8',
    'ttrs',
    'tt',
    'tts',
  ],
};

export const OTHER_MAKES_QUERY_OPTIONS = {
  name: 'otherMakes',
  key: 'otherMakes',
  filterType: 'regularNoCheck',
  options: [],
};

export const NON_AUDI_MODELS_QUERY_OPTIONS = {
  name: 'nonAudiModels',
  key: 'nonAudiModels',
  filterType: 'regularNoCheck',
  options: [],
};

export const COLOR_QUERY_OPTIONS = {
  name: 'exteriorColor',
  key: 'exteriorColor',
  filterType: 'regular',
  options: [
    'black',
    'white',
    'grey',
    'gray',
    'silver',
    'blue',
    'red',
    'green',
    'brown',
    'yellow',
    'beige',
    'orange',
    'default',
  ],
};
export const INTERIOR_QUERY_OPTIONS = {
  name: 'interiorColor',
  key: 'interiorColor',
  filterType: 'regular',
  options: ['black', 'white', 'grey', 'gray', 'red', 'brown', 'beige', 'default'],
};
export const WHEEL_SIZE_QUERY_OPTIONS = {
  name: 'wheelSize',
  key: 'wheelSize',
  filterType: 'regular',
  options: ['15', '16', '17', '18', '19', '20', '21', '22', '23'],
};
export const GEARBOX_QUERY_OPTIONS = {
  name: 'gearbox',
  key: 'gearBox',
  filterType: 'regular',
  options: ['automatic', 'manual'],
};
export const DRIVETRAIN_QUERY_OPTIONS = {
  name: 'drivetrain',
  key: 'drivetrain',
  filterType: 'regular',
  options: ['fwd', 'rwd', 'quattro'],
};
export const FUEL_TYPE_QUERY_OPTIONS = {
  name: 'fuel-type',
  key: 'fuelType',
  filterType: 'regular',
  options: ['diesel', 'gasoline_hybrid', 'gasoline', 'electrical'],
};
export const PRICE_QUERY_OPTIONS = {
  name: 'price',
  key: 'price',
  filterType: 'range',
  options: {
    min: [0, 10000, 20000, 30000, 40000, 50000, 60000, 70000, 80000, 90000, 100000],
    max: [10000, 20000, 30000, 40000, 50000, 60000, 70000, 80000, 90000, 100000, 500000],
  },
};
export const YEAR_QUERY_OPTIONS = {
  name: 'year',
  key: 'modelYear',
  filterType: 'range',
  options: {
    min: [
      2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023,
      2024, 2025,
    ],
    max: [
      2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023,
      2024, 2025,
    ],
  },
};
export const POWER_QUERY_OPTIONS = {
  name: 'power',
  key: 'power',
  filterType: 'range',
  options: {
    min: [0, 200, 250, 300, 350, 400, 450, 500, 600],
    max: [200, 250, 300, 350, 400, 450, 500, 1000],
  },
};
export const MILEAGE_QUERY_OPTIONS = {
  name: 'mileage',
  key: 'mileage',
  filterType: 'range',
  options: {
    min: [0, 25000, 50000, 75000, 100000, 125000, 150000, 175000],
    max: [25000, 50000, 75000, 100000, 125000, 150000, 175000, 500000],
  },
};

export const RANGE_FILTER_QUERY_OPTIONS: RangeFilterOptions = {
  price: PRICE_QUERY_OPTIONS,
  year: YEAR_QUERY_OPTIONS,
  power: POWER_QUERY_OPTIONS,
  mileage: MILEAGE_QUERY_OPTIONS,
};

export const QUERY_FILTERS_OPTIONS: FilterOptionsTypes = {
  type: TYPE_QUERY_OPTIONS,
  'carline-group': CARLINE_GROUP_QUERY_OPTIONS,
  carline: CARLINE_QUERY_OPTIONS,
  'body-style': BODY_STYLE_QUERY_OPTIONS,
  trimline: TRIMLINE_QUERY_OPTIONS,
  modelFamily: MODEL_FAMILY_QUERY_OPTIONS,
  colour: COLOR_QUERY_OPTIONS,
  interior: INTERIOR_QUERY_OPTIONS,
  'wheel-size': WHEEL_SIZE_QUERY_OPTIONS,
  gearbox: GEARBOX_QUERY_OPTIONS,
  drivetrain: DRIVETRAIN_QUERY_OPTIONS,
  'fuel-type': FUEL_TYPE_QUERY_OPTIONS,
  price: PRICE_QUERY_OPTIONS,
  year: YEAR_QUERY_OPTIONS,
  power: POWER_QUERY_OPTIONS,
  mileage: MILEAGE_QUERY_OPTIONS,
  nonAudi: NON_AUDI_QUERY_OPTIONS,
  availableInMonths: AVAILABLE_IN_MONTHS_QUERY_OPTIONS,
  usedInventoryType: USED_INVENTORY_TYPE_QUERY_OPTIONS,
  otherMakes: OTHER_MAKES_QUERY_OPTIONS,
  nonAudiModels: NON_AUDI_MODELS_QUERY_OPTIONS,
};
